import classnames from 'classnames'
import { Field, FieldData, FieldType, PublicClassNames } from 'embed/constants'
import * as React from 'react'
import { Status } from '../Status'
import { useTheme } from 'embed/hooks'

const applicationFieldStyles = require('../styles')

interface Props {
  colorTextSecondary: string
  field: Field
  fontFamilyPrimary: string
  fieldData?: FieldData
  tooltip: React.ReactNode
  useFloatingLabelInputs?: boolean
}

export const Label = ({ field, tooltip, useFloatingLabelInputs, ...props }: Props) => {
  const { labelStyles } = useTheme()

  const { label } = field.options
  if (label === undefined || field.type === FieldType.SliderInput || useFloatingLabelInputs) {
    return null
  }
  const isValid = props.fieldData?.isValid
  const shouldShowIsValid = props.fieldData?.shouldShowValidationStatus === true && isValid === true
  const shouldShowIsInvalid = props.fieldData?.shouldShowValidationStatus === true && isValid === false
  return (
    <label className={PublicClassNames.FormLabel} htmlFor={field.key}>
      <div className={applicationFieldStyles.headerContainer}>
        <div className={applicationFieldStyles.fieldHeaderContainer}>
          <p className={classnames('field-header')} style={labelStyles}>
            {label}
            {tooltip}
          </p>
        </div>
        <p className="validation-header">
          {!field.options.hideValidationStatus && (
            <Status
              field={field}
              isValid={!!isValid}
              shouldShowIsValid={shouldShowIsValid}
              shouldShowIsInvalid={shouldShowIsInvalid}
              {...props}
            />
          )}
        </p>
      </div>
    </label>
  )
}
